module.exports = __webpack_public_path__ + "img/car.5447dcca.png";